export const formatLongRules = (text: string[]): string => {
  const parsedRules = text.map(rule => rule.replace(/{/g, '<strong>').replace(/}/g, '</strong>') + '<br /><br />');
  return parsedRules.join('');
};
